import { TemplateConfig, TemplateId } from '@/types/template';
import { RealtorClassicTemplate } from '@/components/templates/RealtorClassicTemplate';

/**
 * Template Registry
 * Central configuration for all available site templates
 * 
 * To add a new template:
 * 1. Create the template component in src/components/templates/
 * 2. Add a new entry to this registry with a unique ID
 * 3. Update the TemplateId type in src/types/template.ts
 */
export const TEMPLATE_REGISTRY: Record<string, TemplateConfig> = {
  modern_search: {
    id: 'modern_search',
    name: 'Busca Moderna',
    description: 'Foco na busca de imóveis com barra centralizada.',
    component: RealtorClassicTemplate,
    preview: '/previews/modern_search.svg'
  },
  profile: {
    id: 'profile',
    name: 'Cartão de Visitas',
    description: 'Foco no perfil do corretor, perfeito para link na bio.',
    component: RealtorClassicTemplate,
    preview: '/previews/profile.svg'
  }
};

/**
 * Get a template configuration by ID
 * Returns the institutional template as fallback if not found
 */
export const getTemplate = (templateId: string): TemplateConfig => {
  const template = TEMPLATE_REGISTRY[templateId as string];
  
  if (!template) {
    console.warn(`[TemplateRegistry] Template "${templateId}" not found, falling back to modern_search`);
    return TEMPLATE_REGISTRY.modern_search;
  }
  
  return template;
};

/**
 * Get all available templates as an array
 */
export const getAllTemplates = (): TemplateConfig[] => {
  return Object.values(TEMPLATE_REGISTRY);
};

/**
 * Check if a template ID is valid
 */
export const isValidTemplateId = (templateId: string): boolean => {
  return templateId in TEMPLATE_REGISTRY;
};
